import { defineMessages } from 'react-intl';

export const userActionBadgeMessages = defineMessages({
    login: {
        id: 'login',
        defaultMessage: 'Login',
    },
    activeStayEnded: {
        id: 'active-stay-ended',
        defaultMessage: 'Active stay ended',
    },
    gatewayOpened: {
        id: 'gateway-opened',
        defaultMessage: 'Gateway opened',
    },
    emergencyGatewayOpened: {
        id: 'emergency-gateway-opened',
        defaultMessage: 'Emergency gateway opened',
    },
    emergencyGatewayClosed: {
        id: 'emergency-gateway-closed',
        defaultMessage: 'Emergency gateway closed',
    },
    membershipCreated: {
        id: 'membership-created',
        defaultMessage: 'Membership created',
    },
    membershipUpdated: {
        id: 'membership-updated',
        defaultMessage: 'Membership updated',
    },
    membershipDeleted: {
        id: 'membership-deleted',
        defaultMessage: 'Membership deleted',
    },
    membershipIdentifierCreated: {
        id: 'membership-identifier-created',
        defaultMessage: 'Membership identifier created',
    },
    membershipIdentifierUpdated: {
        id: 'membership-identifier-updated',
        defaultMessage: 'Membership identifier updated',
    },
    membershipIdentifierDeleted: {
        id: 'membership-identifier-deleted',
        defaultMessage: 'Membership identifier deleted',
    },
    membershipIdentifierArchived: {
        id: 'membership-identifier-archived',
        defaultMessage: 'Membership identifier archived',
    },
    membershipZoneRuleCreated: {
        id: 'membership-zone-rule-created',
        defaultMessage: 'Membership zone rule created',
    },
    membershipZoneRuleUpdated: {
        id: 'membership-zone-rule-updated',
        defaultMessage: 'Membership zone rule updated',
    },
    membershipZoneRuleDeleted: {
        id: 'membership-zone-rule-deleted',
        defaultMessage: 'Membership zone rule deleted',
    },
    membershipAllowedTimeCreated: {
        id: 'membership-allowed-time-created',
        defaultMessage: 'Membership allowed time created',
    },
    membershipAllowedTimeUpdated: {
        id: 'membership-allowed-time-updated',
        defaultMessage: 'Membership allowed time updated',
    },
    membershipAllowedTimeDeleted: {
        id: 'membership-allowed-time-deleted',
        defaultMessage: 'Membership allowed time deleted',
    },
    membershipCloudUserCreated: {
        id: 'membership-cloud-user-created',
        defaultMessage: 'Membership cloud user created',
    },
    membershipCloudUserUpdated: {
        id: 'membership-cloud-user-updated',
        defaultMessage: 'Membership cloud user updated',
    },
    membershipCloudUserDeleted: {
        id: 'membership-cloud-user-deleted',
        defaultMessage: 'Membership cloud user deleted',
    },
    userCreated: {
        id: 'user-created',
        defaultMessage: 'User created',
    },
    userUpdated: {
        id: 'user-updated',
        defaultMessage: 'User updated',
    },
    userDeleted: {
        id: 'user-deleted',
        defaultMessage: 'User deleted',
    },
    userActivated: {
        id: 'user-activated',
        defaultMessage: 'User activated',
    },
    userDeactivated: {
        id: 'user-deactivated',
        defaultMessage: 'User deactivated',
    },
    entityCreated: {
        id: 'entity-created',
        defaultMessage: 'Entity created',
    },
    entityUpdated: {
        id: 'entity-updated',
        defaultMessage: 'Entity updated',
    },
    entityDeleted: {
        id: 'entity-deleted',
        defaultMessage: 'Entity deleted',
    },
    membershipTypeActivated: {
        id: 'membership-type-activated',
        defaultMessage: 'Membership type activated',
    },
    membershipTypeDeactivated: {
        id: 'membership-type-deactivated',
        defaultMessage: 'Membership type deactivated',
    },
    membershipTypeAllowedTimeCreated: {
        id: 'membership-type-allowed-time-created',
        defaultMessage: 'Membership type allowed time created',
    },
    membershipTypeAllowedTimeUpdated: {
        id: 'membership-type-allowed-time-updated',
        defaultMessage: 'Membership type allowed time updated',
    },
    membershipTypeAllowedTimeDeleted: {
        id: 'membership-type-allowed-time-deleted',
        defaultMessage: 'Membership type allowed time deleted',
    },
    membershipTypeZoneRuleCreated: {
        id: 'membership-type-zone-rule-created',
        defaultMessage: 'Membership type zone rule created',
    },
    membershipTypeZoneRuleUpdated: {
        id: 'membership-type-zone-rule-updated',
        defaultMessage: 'Membership type zone rule updated',
    },
    membershipTypeZoneRuleDeleted: {
        id: 'membership-type-zone-rule-deleted',
        defaultMessage: 'Membership type zone rule deleted',
    },
    cloudUserActivated: {
        id: 'cloud-user-activated',
        defaultMessage: 'Cloud user activated',
    },
    cloudUserDeactivated: {
        id: 'cloud-user-deactivated',
        defaultMessage: 'Cloud user deactivated',
    },
    cloudUserUpdated: {
        id: 'cloud-user-updated',
        defaultMessage: 'Cloud user updated',
    },
    cloudUserDeleted: {
        id: 'cloud-user-deleted',
        defaultMessage: 'Cloud user deleted',
    },
    visitorAddedToParking: {
        id: 'visitor-added-to-parking',
        defaultMessage: 'Visitor added to parking',
    },
});

export const userActionMessages = defineMessages({
    login: {
        id: 'event-log-login-message',
        defaultMessage: 'User logged in',
    },
    activeStayEnded: {
        id: 'event-log-active-stay-ended-message',
        defaultMessage: 'Active stay "{stay}" for identifier "{identifier}" has ended',
    },
    gatewayOpened: {
        id: 'event-log-gateway-opened-message',
        defaultMessage: 'The gateway "{gateway}" was opened.',
    },
    emergencyGatewayOpened: {
        id: 'event-log-emergency-gateway-opened-message',
        defaultMessage: 'The gateway "{gateway}" was urgently opened',
    },
    emergencyGatewayClosed: {
        id: 'event-log-emergency-gateway-closed-message',
        defaultMessage: 'The gateway "{gateway}" was urgently closed',
    },
    membershipCreated: {
        id: 'event-log-membership-created-message',
        defaultMessage: 'Membership "{membership}" was created',
    },
    membershipUpdated: {
        id: 'event-log-membership-updated-message',
        defaultMessage: 'Membership "{membership}" was updated',
    },
    membershipDeleted: {
        id: 'event-log-membership-deleted-message',
        defaultMessage: 'Membership "{membership}" was deleted',
    },
    membershipIdentifierCreated: {
        id: 'event-log-membership-identifier-created-message',
        defaultMessage: 'Membership identifier "{identifier}" for membership "{membership}" was created',
    },
    membershipIdentifierUpdated: {
        id: 'event-log-membership-identifier-updated-message',
        defaultMessage: 'Membership identifier "{identifier}" for membership "{membership}" was updated',
    },
    membershipIdentifierDeleted: {
        id: 'event-log-membership-identifier-deleted-message',
        defaultMessage: 'Membership identifier "{identifier}" for membership "{membership}" was deleted',
    },
    membershipIdentifierArchived: {
        id: 'event-log-membership-identifier-archived-message',
        defaultMessage: 'Membership identifier "{identifier}" for membership "{membership}" was archived',
    },
    membershipZoneRuleCreated: {
        id: 'event-log-membership-zone-rule-created-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership "{membership}" was created',
    },
    membershipZoneRuleUpdated: {
        id: 'event-log-membership-zone-rule-updated-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership "{membership}" was updated',
    },
    membershipZoneRuleDeleted: {
        id: 'event-log-membership-zone-rule-deleted-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership "{membership}" was deleted',
    },
    membershipAllowedTimeCreated: {
        id: 'event-log-membership-allowed-time-created-message',
        defaultMessage: 'Allowed time for membership "{membership}" was created',
    },
    membershipAllowedTimeUpdated: {
        id: 'event-log-membership-allowed-time-updated-message',
        defaultMessage: 'Allowed time for membership "{membership}" was updated',
    },
    membershipAllowedTimeDeleted: {
        id: 'event-log-membership-allowed-time-deleted-message',
        defaultMessage: 'Allowed time for membership "{membership}" was deleted',
    },
    membershipCloudUserCreated: {
        id: 'event-log-membership-cloud-user-created-message',
        defaultMessage: 'Cloud user "{user}" for membership "{membership}" was created',
    },
    membershipCloudUserUpdated: {
        id: 'event-log-membership-cloud-user-updated-message',
        defaultMessage: 'Cloud user "{user}" for membership "{membership}" was updated',
    },
    membershipCloudUserDeleted: {
        id: 'event-log-membership-cloud-user-deleted-message',
        defaultMessage: 'Cloud user "{user}" for membership "{membership}" was deleted',
    },
    membershipTypeAllowedTimeCreated: {
        id: 'event-log-membership-type-allowed-time-created-message',
        defaultMessage: 'Allowed time for membership type "{membershipType}" was created',
    },
    membershipTypeAllowedTimeUpdated: {
        id: 'event-log-membership-type-allowed-time-updated-message',
        defaultMessage: 'Allowed time for membership type "{membershipType}" was updated',
    },
    membershipTypeAllowedTimeDeleted: {
        id: 'event-log-membership-type-allowed-time-deleted-message',
        defaultMessage: 'Allowed time for membership type "{membershipType}" was deleted',
    },
    membershipTypeActivated: {
        id: 'event-log-membership-type-activated-message',
        defaultMessage: 'Membership type "{membershipType}" was activated',
    },
    membershipTypeDeactivated: {
        id: 'event-log-membership-type-deactivated-message',
        defaultMessage: 'Membership type "{membershipType}" was deactivated',
    },
    membershipTypeZoneRuleCreated: {
        id: 'event-log-membership-type-zone-rule-created-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership type "{membershipType}" was created',
    },
    membershipTypeZoneRuleUpdated: {
        id: 'event-log-membership-type-zone-rule-updated-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership type "{membershipType}" was updated',
    },
    membershipTypeZoneRuleDeleted: {
        id: 'event-log-membership-type-zone-rule-deleted-message',
        defaultMessage: 'Zone rule for zone "{zone}" in membership type "{membershipType}" was deleted',
    },
    entityCreated: {
        id: 'event-log-entity-created-message',
        defaultMessage: 'Entity "{name}" was created',
    },
    entityUpdated: {
        id: 'event-log-entity-updated-message',
        defaultMessage: 'Entity "{name}" was updated',
    },
    entityDeleted: {
        id: 'event-log-entity-deleted-message',
        defaultMessage: 'Entity "{name}" was deleted',
    },
    userCreated: {
        id: 'event-log-user-created-message',
        defaultMessage: 'User "{name}" was created',
    },
    userUpdated: {
        id: 'event-log-entity-updated-message',
        defaultMessage: 'User "{name}" was updated',
    },
    userDeleted: {
        id: 'event-log-entity-deleted-message',
        defaultMessage: 'User "{name}" was deleted',
    },
    userActivated: {
        id: 'event-log-user-activated-message',
        defaultMessage: 'User "{name}" was activated',
    },
    userDeactivated: {
        id: 'event-log-user-deactivated-message',
        defaultMessage: 'User "{name}" was deactivated',
    },
    cloudUserActivated: {
        id: 'event-log-cloud-user-activated-message',
        defaultMessage: 'Cloud user "{name}" was activated',
    },
    cloudUserDeactivated: {
        id: 'event-log-cloud-user-deactivated-message',
        defaultMessage: 'Cloud user "{name}" was deactivated',
    },
    cloudUserUpdated: {
        id: 'event-log-cloud-user-updated-message',
        defaultMessage: 'Cloud user "{name}" was updated',
    },
    cloudUserDeleted: {
        id: 'event-log-cloud-user-deleted-message',
        defaultMessage: 'Cloud user "{name}" was deleted',
    },
    visitorAddedToParking: {
        id: 'event-log-visitor-added-to-parking',
        defaultMessage: 'Visitor "{visitor}" was added to the parking',
    },
});
